import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-5xl mb-12" }
const _hoisted_2 = { class: "inline-flex items-center gap-2 bg-gray-100 rounded-full pl-1 pr-3 py-1 mb-8" }
const _hoisted_3 = { class: "inline-flex items-center gap-1 bg-gray-900 text-yellow-300 text-[10px] font-bold uppercase rounded-full px-2 py-0.5" }

import { SparklesIcon } from '@heroicons/vue/24/outline'

import { neueButtonClasses } from '@/components/neue/neueButtonClasses'
import { WIZARD_PATH } from '@/config/agentWizardSteps'

export default {
  __name: 'AgentsIntro',
  setup(__props) {


return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_unref(SparklesIcon), { class: "h-3 w-3" }),
        _cache[0] || (_cache[0] = _createTextVNode(" New ", -1))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Now in your dashboard", -1))
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6" }, " Enable AI agents and drive your business forward ", -1)),
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-lg text-gray-500 max-w-2xl" }, " Introducing Bottle's new AI agents that help you run your business, driving more sales and repeat orders, winning back customers who are slipping away, and earning more Google reviews. Set them up per store below. More agents coming soon. ", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-lg text-gray-500 max-w-2xl mt-4" }, " A short guided setup explains each agent and lets you test it on your own phone before anything goes live. ", -1)),
    _createVNode(_component_router_link, {
      to: _unref(WIZARD_PATH),
      class: _normalizeClass([_unref(neueButtonClasses)({ type: 'primary', size: 'md' }), 'mt-6'])
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode(" Set up AI agents → ", -1)
      ]))]),
      _: 1
    }, 8, ["to", "class"])
  ]))
}
}

}